export type RecommendedCompsStatusGroup = 'sold' | 'active' | 'pending';

export const RECOMMENDED_COMPS_STATUS_GROUP_ORDER: RecommendedCompsStatusGroup[] = [
  'sold',
  'active',
  'pending',
];

export const RECOMMENDED_COMPS_STATUS_GROUP_LABELS: Record<RecommendedCompsStatusGroup, string> = {
  sold: 'Sold Transactions',
  active: 'Active Listings',
  pending: 'Pending Listings',
};

export const getStatusGroup = (mlsStatus?: string): RecommendedCompsStatusGroup | undefined => {
  switch (mlsStatus?.toLowerCase()) {
    case 'sold':
    case 'recently_sold':
      return 'sold';
    case 'active':
      return 'active';
    case 'pending':
      return 'pending';
    default:
      return undefined;
  }
};
